import {
  GET_MATCH_CARD_STANDINGS_REQUEST,
  GET_MATCH_CARD_STANDINGS_SUCCESS,
  GET_MATCH_CARD_STANDINGS_FAILURE,
  RESET_MATCH_CARD
} from 'Store/constants';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

let hasStandingTable;

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_STANDINGS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_MATCH_CARD_STANDINGS_SUCCESS:

      hasStandingTable = isEmpty(action.payload.standings.generalStandings)
        || isEmpty(action.payload.standings.standingsAtAway)
        || isEmpty(action.payload.standings.standingsAtHome);

      return {
        data: {
          ...action.payload,
          hasStandingTable: !hasStandingTable,
        }, isLoading: false, error: null
      };
    case GET_MATCH_CARD_STANDINGS_FAILURE:
      return { ...state, isLoading: true, error: action.payload };

    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
